import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Card } from '../../../components/ui/card';
import { Separator } from '../../../components/ui/separator';
import { useTelegramBackButton } from '../../../utils/BackButton';
import { userInfo } from '../../../store/selectors/user';
import { formatPhoneNumber } from '../../../utils/formatPhone';
import { useState } from 'react';
import { NameDrawer } from '../../../components/NameDrawr';
import { EditChevron } from './EditChevron';
import { EditPencilIcon } from '../../../assets/EditPencil';
import { ChangePhoneDrawer } from '../../profile/ui/ChangePhoneDrawer';
import { GenderDrawer } from '@/components/GenderDrawer';
import { EmailInfo } from './EmailInfo';
import { BirthdayInfo } from './BirthdayInfo';
import { Gender } from '@/store/slices/userSlice';

export const UserInfo = () => {
  useTelegramBackButton('/profile');

  const { t } = useTranslation();
  const user = useSelector(userInfo);
  const [nameOpen, setNameOpen] = useState(false);
  const [phoneOpen, setPhoneOpen] = useState(false);
  const [genderOpen, setGenderOpen] = useState(false);

  return (
    <div className="flex h-full flex-col overflow-y-auto p-4">
      <div className="flex flex-col space-y-7">
        <p className="text-display-sm text-center">{t('personalDataTitle')}</p>
        <div className="flex flex-col space-y-4">
          <Card className="flex flex-col rounded-xl pl-4 py-[11px]">
            <div className="flex flex-col space-y-[12px]">
              <div
                className="flex flex-row items-center justify-between"
                onClick={() => setNameOpen(true)}
              >
                <p className="text-body-base-regular text-text-primary">
                  {t('nameLabel')}
                </p>
                <div className="flex flex-row items-center gap-2 pr-4">
                  <p className="text-body-base-regular text-text-tertiary">
                    {user.name}
                  </p>
                  <EditChevron />
                </div>
              </div>
              <Separator className="mt-2" />
              <div
                className="flex flex-row items-center justify-between"
                onClick={() => setPhoneOpen(true)}
              >
                <p className="text-body-base-regular text-text-primary">
                  {t('phoneLabel')}
                </p>
                <div className="flex flex-row items-center gap-2 pr-4">
                  <p className="text-body-base-regular text-text-tertiary">
                    {formatPhoneNumber(user.phone)}
                  </p>
                  <EditPencilIcon className="shrink-0 text-brand-green" />
                </div>
              </div>
              <Separator className="mt-2" />
              <div
                className="flex flex-row items-center justify-between"
                onClick={() => setGenderOpen(true)}
              >
                <p className="text-body-base-regular text-text-primary">
                  {t('gender.title')}
                </p>
                <div className="flex flex-row items-center gap-2 pr-4">
                  {user?.gender ? (
                    <p className="text-body-base-regular text-text-tertiary">
                      {user.gender === Gender.MALE
                        ? t('gender.male')
                        : t('gender.female')}
                    </p>
                  ) : (
                    <p className="text-body-base-regular text-brand-green">
                      {t('specify')}
                    </p>
                  )}
                  <EditChevron />
                </div>
              </div>
              <Separator className="mt-2" />
              <BirthdayInfo />
            </div>
          </Card>

          <EmailInfo />
        </div>
      </div>
      <NameDrawer open={nameOpen} setOpen={setNameOpen} />
      <ChangePhoneDrawer open={phoneOpen} setOpen={setPhoneOpen} />
      <GenderDrawer open={genderOpen} setOpen={setGenderOpen} />
    </div>
  );
};
export default UserInfo;
